import React, { ReactNode } from "react";
import TopBar from "./TopBar";
import { makeStyles } from "@material-ui/core";
import Wrapper from "./Wrapper";
import clsx from "clsx";

interface Props {
  children?: ReactNode;
}

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
  },
  mask1: {
    pointerEvents: "none",
    userSelect: "none",
    position: "fixed",
    top: 0,
    right: 0,
  },
  mask2: {
    pointerEvents: "none",
    userSelect: "none",
    position: "fixed",
    bottom: 0,
    left: 0,
  },
}));

const SingleLayout: React.FC<Props> = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, "single-layout")}>
      <TopBar type="single" />
      <Wrapper>{children}</Wrapper>
    </div>
  );
};

export default SingleLayout;
